import styled from 'styled-components';

export const SectionTitle = styled.h2`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: var(--colBlack);
  /* padding: 0 20px; */
  margin-bottom: 20px;
  @media screen and (min-width: 768px) {
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
  }
`;
